import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

import { AppConfig } from './../../Common/appConfiguration';
import { Utility } from './../../Common/Services/utility';


/**
 * HOW TO USE :
 * 1. use dateTimeFormat pipe where you have to display date.
 * 2. Default Date Time format "YYYY-MM-DD hh:mm"
 * 3. In Case , you want to use custom format : do like => {{date | dateTimeFormat : 'yourFormat'}}
 */
@Pipe({ name: 'dateTimeFormat' })
export class DateTimeFormatPipe implements PipeTransform {
    constructor(private _utility: Utility, private _appConfig: AppConfig) {
    }

    transform(dateStr: any, customFormat: any, additional): any {
        if (dateStr) {
            //alert(customFormat);
            let date = this._utility.convertToDateTime(dateStr);//new Date(date);
            let time = dateStr.split(' ')[1]; // split date string and get time part
            if (!customFormat) {
                //return additional ? moment(date).format(time ? dateTimeFormat : dateFormat) + ` (${additional})` : moment(date).format(time ? dateTimeFormat : dateFormat); // If there are any additional value is coming than append that into final return value
                return additional ? moment(date).format(time ? this._appConfig.dateTimeFormat : this._appConfig.dateFormat) + ` (${additional})` : moment(date).format(time ? this._appConfig.dateTimeFormat : this._appConfig.dateFormat); // If there are any additional value is coming than append that into final return value
            } else {
                return additional ? moment(date).format(customFormat) + ` (${additional})` : moment(date).format(customFormat);
            }
        }
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Pipe/date-time-format.pipe.ts